import { atom } from "recoil";

export enum EPages {
  DISTRIBUTION_SETUP = 0,
}

const state = atom({
  key: "15-15-state",
  default: EPages.DISTRIBUTION_SETUP
});

export default state;
